import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import type { FetchAgencyJobsHistoryAction } from './actions'
import type { AgencyJobHistoryEntry, AgencyJobsHistoryQuery } from './types'

type AgencyJobsHistoryResult = {
  payload: ReadonlyArray<AgencyJobHistoryEntry>
  response: Response
  meta: { options: AgencyJobsHistoryQuery }
}

export const listAgencyJobsHistory = ({
  options,
}: FetchAgencyJobsHistoryAction): Promise<AgencyJobsHistoryResult> =>
  new Promise((resolve, reject) => {
    handleCall(
      apiRequest({
        path: `/admin/jobs/${options.job_id}/agency_jobs_history`,
        reqArgs: options.shift_id ? { shift_id: options.shift_id } : {},
        method: 'GET',
      }),
      resolve,
      reject,
      true,
      // Echoed back as `options` on the success action so the result lands in this job's set.
      options,
    )
  })
